import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserProfileDropdown from './UserProfileDropdown';
import '../styles/components/Header.css';

export interface HeaderProps {
  // Content configuration
  pageTitle?: string;
  interactionExId?: string;
  userName?: string;
  userEmail?: string;
  userAvatar?: string;
  
  // Visibility toggles
  showPageTitle?: boolean;
  showInteractionExId?: boolean;
  showUserInfo?: boolean;
  showUserAvatar?: boolean;
  showClientLogo?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  pageTitle = '',
  interactionExId = '',
  userName = '',
  userEmail = '',
  userAvatar = '',
  
  showPageTitle = true,
  showInteractionExId = true,
  showUserInfo = false,
  showUserAvatar = false,
  showClientLogo = true,
}) => {
  const { isAuthenticated } = useAuth();

  return (
    <header className="header">
      <div className="header-left">
        {showClientLogo && <div className="client-logo">Client Logo</div>}
        {showPageTitle && pageTitle && <div className="page-title">{pageTitle}</div>}
        {showInteractionExId && interactionExId && (
          <div className="interaction-ex-id">{interactionExId}</div>
        )}
      </div>
      
      <div className="header-center">
        {/* Additional page-specific controls will go here */}
      </div>
      
      <div className="header-right">
        {showUserInfo && userName && (
          <div className="user-info">
            <div className="user-name">{userName}</div>
            {userEmail && <div className="user-email">{userEmail}</div>}
          </div>
        )}
        {showUserAvatar && userAvatar && isAuthenticated && (
          <UserProfileDropdown
            userAvatar={userAvatar}
            userName={userName}
            userEmail={userEmail}
          />
        )}
      </div>
    </header>
  );
};

export default Header;